import { iconMap } from "./getIcons";
const Icon = ({ name, props }: { name: string; props?: any }) => {
  const SvgIcon = iconMap[name];
  return <SvgIcon {...props} />;
};
export default Icon;
